// Native deep links (e.g. https://app.tradeprep.nz/checkout/success?... or
// nz.tradeprep.app://reset-password) are routed into React Router.

import { App } from '@capacitor/app';
import { isNative } from './platform';
import { closeExternal } from './browser';

export function registerDeepLinks(navigate: (path: string) => void): () => void {
  if (!isNative()) return () => undefined;
  const sub = App.addListener('appUrlOpen', ({ url }) => {
    try {
      const parsed = new URL(url);
      const path = parsed.protocol.startsWith('http') ? parsed.pathname : `/${parsed.host}${parsed.pathname}`;
      void closeExternal();
      navigate(`${path}${parsed.search}${parsed.hash}`);
    } catch {
      /* ignore malformed links */
    }
  });
  return () => {
    void sub.then((h) => h.remove());
  };
}
